import { Link } from 'react-router-dom';

const footerLinks = {
  products: {
    title: '产品中心',
    links: [
      { label: '水基润滑液', to: '/categories' },
      { label: '硅基润滑液', to: '/categories' },
      { label: '天然植萃系列', to: '/categories' },
      { label: '全部产品', to: '/categories' }
    ]
  },
  guide: {
    title: '健康百科',
    links: [
      { label: '选购指南', to: '/articles' },
      { label: '使用指南', to: '/articles' },
      { label: '成分解析', to: '/articles' },
      { label: '健康科普', to: '/articles' }
    ]
  },
  about: {
    title: '关于我们',
    links: [
      { label: '品牌故事', to: '/about' },
      { label: '品牌信誉', to: '/about' },
      { label: '联系我们', to: '/about' },
      { label: '常见问题', to: '/about' }
    ]
  },
  legal: {
    title: '法律信息',
    links: [
      { label: '隐私政策', to: '/about' },
      { label: '服务条款', to: '/about' },
      { label: '退换政策', to: '/about' },
      { label: '防伪查询', to: '/about' }
    ]
  }
};

export default function Footer() {
  return (
    <footer className="bg-secondary-50 border-t border-secondary-200">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8">
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-500 text-background-50">
                <i className="ri-drop-fill text-lg"></i>
              </div>
              <span className="text-xl font-heading font-semibold text-foreground-900">
                爱液
              </span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed">
              科学私护，温柔以待。<br />
              爱液 - 专业私密健康护理品牌
            </p>
            <div className="flex items-center gap-3 mt-5">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-100 text-foreground-600 hover:text-primary-500 hover:bg-primary-50 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-100 text-foreground-600 hover:text-primary-500 hover:bg-primary-50 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-100 text-foreground-600 hover:text-primary-500 hover:bg-primary-50 transition-colors cursor-pointer" aria-label="小红书">
                <i className="ri-red-packet-line text-lg"></i>
              </a>
            </div>
          </div>

          {Object.values(footerLinks).map((section) => (
            <div key={section.title}>
              <h4 className="text-sm font-semibold text-foreground-900 mb-4">
                {section.title}
              </h4>
              <ul className="space-y-2.5">
                {section.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-secondary-200 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; 2025 爱液品牌官方网站 版权所有 | 粤ICP备XXXXXXXX号
          </p>
          <div className="flex items-center gap-4">
            <span className="text-xs text-foreground-500">官方正品 · 品质保障</span>
            <span className="text-xs text-foreground-500">隐私配送 · 安全无忧</span>
          </div>
        </div>
      </div>
    </footer>
  );
}